import axios from "../../../config/axiosConfig";

export const listProductos = () => axios.get("/api/telusgy/productos");

export const createProducto = (body) => axios.post("/api/telusgy/productos", body);

export const updateProducto = (id, body) => axios.put(`/api/telusgy/productos/${id}`, body);

export const deleteProducto = (id) => axios.delete(`/api/telusgy/productos/${id}`);
